import { CondenseIcon } from '#assets/ReactSvg.ts';
import { IconButton } from '#components/atoms/buttons/icon/icon-button/IconButton.tsx';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';

type Props = {
  onClick: () => void;
};

export function CondenseButton({ onClick }: Props) {
  return (
    <Tooltip
      content="Condense commands"
      placement="left"
      render={
        <IconButton title="Condense commands" onClick={onClick}>
          <CondenseIcon />
        </IconButton>
      }
    />
  );
}
